import { Button, Center, Container, Group, Stack, Text, Title } from "@mantine/core";

export default function PageForbidden() {
  return (
    <Container>
      <Center mt="20vh">
        <Stack gap="xl">
          <Stack gap="xs">
            <Title>Access Denied</Title>
            <Text size="lg">You don&apos;t have permission to access this resource.</Text>
            <Text>
              Please contact your administrator if you believe this is an error, or try switching to a different team if
              you have access to multiple teams.
            </Text>
          </Stack>
          <Group gap="xs">
            <Button variant="light" onClick={() => (document.location.href = "/")} maw="200">
              Go to Home
            </Button>
            <Button variant="light" onClick={() => history.back()} maw="200">
              Go Back
            </Button>
          </Group>
        </Stack>
      </Center>
    </Container>
  );
}
